import React, { useState, createContext, useContext } from 'react';
type Lang = 'ru' | 'en';
interface LanguageContextType {
  lang: Lang;
  toggleLang: () => void;
  t: (key: string) => string;
}
const translations: Record<Lang, Record<string, string>> = {
  ru: {
    // Header
    'header.login': 'Войти',
    'header.register': 'Регистрация',
    // Hero
    'hero.badge': 'Новый формат знакомств',
    'hero.title1': 'Ваше время имеет',
    'hero.title2': 'значение!',
    'hero.subtitle': 'Хватит листать ленту. Поручите рутину нам.',
    'hero.cta1': 'Присоединяйся',
    'hero.cta2': 'Как это работает',
    // About
    'about.badge': 'О нас',
    'about.title': 'Настоящие знакомства с',
    'about.text1': 'SVT помогает выйти за рамки бесконечного свайпа. Вы рассказываете о себе и ставите задачу нашему агенту — он делает всю работу за вас: подбирает пары по вашим требованиям и отсеивает лишнее. Ваш персональный ИИ-ассистент проведёт 1000 диалогов одновременно и подберёт то, что вы хотите.',
    'about.text2': 'Вам останется лишь собраться на свидание и выбрать ресторан.',
    // Why Different
    'why.title1': 'Почему SVT — это',
    'why.title2': 'по-другому',
    'why.card1.title': 'Экономия вашего времени!',
    'why.card1.desc': 'Никакого бесконечного свайпа и мейт. Вы ставите заявку, и SVT агент знакомит вас с нужными людьми, отсеивая 98% неподходящих кандидатов — чтобы вы могли сосредоточиться на приятном и полезном.',
    'why.card2.title': 'Никакого негативного опыта общения',
    'why.card2.desc': 'SVT на этапе знакомства проверяет обманщиков, мошенников, грубиянов, кустозалов, состоящих в браке и т.д. По фото определяет реальный возраст, вес, рост. Вы не вступаете в диалог с токсичными людьми.',
    'why.card3.title': 'Только правильные кандидаты',
    'why.card3.desc': 'Вы получаете всю информацию, которую хотели бы узнать о кандидате, в ключевых параметрах — вес, рост, увлечения, хобби, семейное и материальное положение и др. Отбор по вашим требованиям и критериям подбирает людей, которые действительно соответствуют вашим ожиданиям.',
    // How It Works
    'how.title': 'Как это работает',
    'how.step1.title': 'Расскажите о себе',
    'how.step1.desc': 'Вы предоставляете ту информацию о себе, которую считаете важной: чем подробнее и интереснее — тем проще нашему SVT агенту строить диалог с потенциальными кандидатами.',
    'how.step2.title': 'Ставьте задачи SVT-агенту',
    'how.step2.desc': 'Подробно опишите характеристики кандидата: возраст, телосложение, рост, материальное состояние, положение, хобби и т.д. Наш SVT-агент анализирует фото, манеру диалога, хобби и интересы, может проводить психологические тесты на совместимость.',
    'how.step3.title': 'Получите результат',
    'how.step3.desc': 'В результате вы получаете несколько кандидатов, полностью подходящих вашим критериям, которых вы можете пригласить на встречу или принять приглашение!',
    // Security
    'security.title1': 'Безопасность',
    'security.title2': 'прежде всего',
    'security.item1.title': 'Без разглашения информации',
    'security.item1.desc': 'Ваши личные данные надёжно защищены и никогда не передаются третьим лицам.',
    'security.item2.title': 'Личные данные полностью сохранены',
    'security.item2.desc': 'Современные технологии шифрования обеспечивают полную сохранность ваших данных.',
    'security.item3.title': 'Ваши контакты видны только после одобрения',
    'security.item3.desc': 'Вы сами решаете, кому открыть доступ к вашим контактным данным.',
    // Pricing
    'pricing.title': 'Тарифы',
    'pricing.basic': 'Базовый',
    'pricing.standard': 'Стандарт',
    'pricing.premium': 'Премиум',
    'pricing.month': '/мес',
    'pricing.quarter': '/3 мес',
    'pricing.year': '/год',
    'pricing.popular': 'Популярный',
    'pricing.trial': '3 дня бесплатно',
    'pricing.select': 'Выбрать',
    // CTA
    'cta.title1': 'Начните знакомства',
    'cta.title2': 'по-новому',
    'cta.subtitle': 'Зарегистрируйтесь на сайте и сделайте первый шаг к осмысленным знакомствам.',
    'cta.button': 'Регистрация',
    // Footer
    'footer.rights': '© 2026 SVT Dating. Все права защищены.'
  },
  en: {
    // Header
    'header.login': 'Log In',
    'header.register': 'Sign Up',
    // Hero
    'hero.badge': 'A New Way to Date',
    'hero.title1': 'Your time matters!',
    'hero.title2': '',
    'hero.subtitle': 'Stop scrolling endlessly. Let us handle the routine.',
    'hero.cta1': 'Join Now',
    'hero.cta2': 'How It Works',
    // About
    'about.badge': 'About Us',
    'about.title': 'Real connections with',
    'about.text1': 'SVT helps you go beyond endless swiping. You tell us about yourself and set a task for our agent — it does all the work for you: matches pairs based on your requirements and filters out the rest. Your personal AI assistant will conduct 1,000 conversations simultaneously and find exactly what you want.',
    'about.text2': 'All you need to do is get ready for a date and pick a restaurant.',
    // Why Different
    'why.title1': 'Why SVT is',
    'why.title2': 'different',
    'why.card1.title': 'Save your time!',
    'why.card1.desc': 'No endless swiping. You submit a request, and the SVT agent introduces you to the right people, filtering out 98% of unsuitable candidates — so you can focus on what matters.',
    'why.card2.title': 'No negative dating experiences',
    'why.card2.desc': 'SVT screens out scammers, fraudsters, rude people, married individuals, and more during the introduction phase. It verifies real age, weight, and height from photos. You never engage with toxic people.',
    'why.card3.title': 'Only the right candidates',
    'why.card3.desc': "You receive all the information you'd want to know about a candidate in key parameters — weight, height, hobbies, interests, family and financial status, and more. Selection based on your criteria finds people who truly match your expectations.",
    // How It Works
    'how.title': 'How It Works',
    'how.step1.title': 'Tell us about yourself',
    'how.step1.desc': 'Provide the information about yourself that you consider important: the more detailed and interesting — the easier it is for our SVT agent to build conversations with potential candidates.',
    'how.step2.title': 'Set tasks for the SVT agent',
    'how.step2.desc': 'Describe your ideal candidate in detail: age, body type, height, financial status, hobbies, etc. Our SVT agent analyzes photos, conversation style, hobbies and interests, and can run psychological compatibility tests.',
    'how.step3.title': 'Get your results',
    'how.step3.desc': 'As a result, you receive several candidates who fully match your criteria, whom you can invite on a date or accept an invitation from!',
    // Security
    'security.title1': 'Security',
    'security.title2': 'comes first',
    'security.item1.title': 'No data disclosure',
    'security.item1.desc': 'Your personal data is securely protected and never shared with third parties.',
    'security.item2.title': 'Personal data fully preserved',
    'security.item2.desc': 'Modern encryption technologies ensure complete safety of your data.',
    'security.item3.title': 'Your contacts visible only after approval',
    'security.item3.desc': 'You decide who gets access to your contact information.',
    // Pricing
    'pricing.title': 'Pricing',
    'pricing.basic': 'Basic',
    'pricing.standard': 'Standard',
    'pricing.premium': 'Premium',
    'pricing.month': '/mo',
    'pricing.quarter': '/3 mo',
    'pricing.year': '/yr',
    'pricing.popular': 'Popular',
    'pricing.trial': '3 days free',
    'pricing.select': 'Select',
    // CTA
    'cta.title1': 'Start dating',
    'cta.title2': 'the new way',
    'cta.subtitle': 'Sign up and take the first step toward meaningful connections.',
    'cta.button': 'Sign Up',
    // Footer
    'footer.rights': '© 2026 SVT Dating. All rights reserved.'
  }
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Lang>('ru');
  const toggleLang = () => {
    setLang(prev => prev === 'ru' ? 'en' : 'ru');
  };
  const t = (key: string): string => {
    return translations[lang][key] ?? key;
  };
  return <LanguageContext.Provider value={{
    lang,
    toggleLang,
    t
  }} data-id="element-128">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}